import React from 'react'

import ProfileActivity from './components/ProfileActivity'
import ProfileCard from './components/ProfileCard'
import PublicGroups from './components/PublicGroups'

import styles from './styles.module.scss'

export default function RightContainer() {
  return (
    <div className={`${styles.rightContainer}`}>
      <ProfileCard />
      <ProfileActivity />
      <PublicGroups />
    </div>
  )
}
